import { getCounts, getText, removeAccents } from "./helper";

// Scores
export const semanticsScoreWeights = [
  50, // Target Keyword Density
  50, // Target Keyword Placement
];

export const semanticsScoreWeightsWithOptScores = [
  30, // Target Keyword Density
  30, // Target Keyword Placement
  20, // Well Optimized
  20, // Over Optimized
];

// Keyword Count
export const keywordCount = (keyword, text) => {
  const regex = new RegExp(`\\b${keyword}\\b`, "gi"); // \b ensures full-word match
  return (text.match(regex) || []).length;
};

// Regex Generator
export const generateRegex = (query, maxGap = 10) => {
  let words = query.toLowerCase().split(/\s+/);

  let escapedWords = words.map((word) =>
    word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  );

  let regexPattern = escapedWords
    .map((word) => `\\b${word}\\b`)
    .join(`[\\w\\s,;:'"\\-]{0,${maxGap}}`);

  return new RegExp(regexPattern, "gi");
};

// Count Matches
export const countMatches = (query, text, maxGap = 20) => {
  let regex = generateRegex(removeAccents(query), maxGap);
  let matches = removeAccents(text).match(regex);
  return matches ? matches.length : 0;
};

// Keyword Count
export const handleCountKeyword = (keyword, formikProps) => {
  const text =
    getText(formikProps.values.introduction.trim()).toLowerCase().trim() +
    getText(formikProps.values.content.trim()).toLowerCase().trim() +
    getText(formikProps.values.conclusion.trim()).toLowerCase().trim();
  return keywordCount(removeAccents(keyword), removeAccents(text));
};

// Well Optimized Score Calculation
export const calculateWellOptimizedScore = (keywords_analysis, formikProps) => {
  let score = 0;

  const wordCount =
    getCounts(
      getText(
        formikProps.values.h1_title.trim() +
          formikProps.values.introduction.trim() +
          formikProps.values.content.trim() +
          formikProps.values.conclusion.trim()
      )
        .toLowerCase()
        .trim()
    ).words || formikProps.values.nb_words;

  keywords_analysis?.secondary_keywords?.forEach((item) => {
    const keywordCount = handleCountKeyword(item?.keywords, formikProps);
    if (keywordCount >= Math.round((item.low / 100) * wordCount)) {
      score += 1;
    }
  });
  console.log(score);
  return (score / keywords_analysis?.secondary_keywords?.length) * 100;
};

// Over Optimized Score Calculation
export const calculateOverOptimizedScore = (keywords_analysis, formikProps) => {
  let score = 0;

  const wordCount =
    getCounts(
      getText(
        formikProps.values.h1_title.trim() +
          formikProps.values.introduction.trim() +
          formikProps.values.content.trim() +
          formikProps.values.conclusion.trim()
      )
        .toLowerCase()
        .trim()
    ).words || formikProps.values.nb_words;

  keywords_analysis?.secondary_keywords?.forEach((item) => {
    const keywordCount = handleCountKeyword(item?.keywords, formikProps);
    if (keywordCount >= Math.round((item.high / 100) * wordCount)) {
      score += 1;
    }
  });
  return (score / keywords_analysis?.secondary_keywords?.length) * 100;
};
